import { useAtom } from "jotai";

import { languageVar } from "@/variables/globalVar";
import { Separator } from "shared/components";
import { getText } from "shared/lib";

export function MultiLingualDisclaimer() {
  const [language] = useAtom(languageVar);

  if (language && language !== "en") {
    return (
      <>
        <Separator orientation="horizontal" />

        <p className="text-bodymd text-textPrimary">
          {getText(
            "🤖 ️This report's translation was generated by AI and may contain errors. The report's English version may be more reliable for planners to review.",
          )}
        </p>
      </>
    );
  }
}